import { ThreeDots } from "react-loader-spinner";

import { useProtectedRoute } from "../../hooks/useProtectedRoute";

function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading } = useProtectedRoute();

  // Show loading indicator while checking authentication
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <ThreeDots />
      </div>
    );
  }

  // If not authenticated, useProtectedRoute will handle navigation
  if (!isAuthenticated) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <ThreeDots />
      </div>
    );
  }

  return children;
}

export default ProtectedRoute;
